import { LegacyDocumentType } from '@commenda/prisma';
import { fetcher } from '@commenda/utils';
import { DocumentNames } from '@commenda/utils/enums';

export async function generateDocument(
  body: {
    documentType: LegacyDocumentType;
    corporationId: number;
    serviceRequestId: string;
  },
  nextAuthToken: string
): Promise<{
  fileUrl: string;
  key: string;
  documentName: DocumentNames;
} | null> {
  try {
    const res = await fetcher(
      `file/generate`,
      {
        method: 'POST',
        body,
      },
      nextAuthToken
    );

    if (!res.ok) return null;

    const response = await res.json();

    return response.document;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
export async function generateMultipleDocuments(body: {
  templateNames: DocumentNames[];
  corporationId: number;
  serviceRequestTaskId: number;
}): Promise<
  | {
      fileUrl: string;
      key: string;
      documentName: DocumentNames;
    }[]
  | null
> {
  try {
    const res = await fetcher(
      `file/generate_multiple`,
      {
        method: 'POST',
        body,
      },
      undefined
    );

    if (!res.ok) return null;

    const response = await res.json();

    return response;
  } catch (err) {
    console.error(err, 'errorObject');
    throw err;
  }
}
